import { Create, SaveButton, SimpleForm } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { UserPlus } from "lucide-react";
import "../HR.css";
import {
    EmployeeBankInputs,
    EmployeeCoreInputs,
    EmployeeGovernmentInputs,
    EmployeePersonalInputs,
} from "./EmployeeInputs";

const EmployeeCreateToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Create Employee" />
  </div>
);

export const EmployeeCreate = () => (
  <Create title="Onboard New Employee">
    <Card className="form-container">
      <div className="form-header-premium">
        <UserPlus className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Onboard New Employee</h2>
      </div>
      <SimpleForm toolbar={<EmployeeCreateToolbar />}>
        <div className="space-y-8">
          <EmployeeCoreInputs />
          <EmployeePersonalInputs />
          <EmployeeGovernmentInputs />
          <EmployeeBankInputs />
        </div>
      </SimpleForm>
    </Card>
  </Create>
);

